export const USER_ACTION_TYPES = {
    SET_ACCESS_TOKEN: "user/SET_ACCESS_TOKEN",
    DELETE_ACCESS_TOKEN: "user/DELETE_ACCESS_TOKEN",
    SET_IS_LOGGED_IN: "user/SET_IS_LOGGED_IN",
    SET_DAY: "user/SET_DAY"
}